import styled from 'styled-components/macro';

export const Container = styled.div`
  background-color: #fff;
  border: 1px solid #e8e8e8;
  box-sizing: border-box;
  color: rgba(0, 0, 0, 0.65);
  cursor: pointer;
  margin: 1rem;
  padding: 0;
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.5;
  list-style: none;
  font-feature-settings: 'tnum';
  position: relative;
  border-radius: 2px;
  max-width: 100%;

  @media only screen and (min-width: 768px) {
    max-width: 350px;
  }

  :hover {
    border-color: rgba(0, 0, 0, 0.09);
    -webkit-box-shadow: 0 2px 8px rgba(0, 0, 0, 0.09);
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.09);
  }
`;

export const Header = styled.div`
  display: flex;
  padding: 16px;
  align-items: center;
  justify-content: space-between;
`;

export const HeaderText = styled.div`
  font-size: 1.1rem;
  font-weight: 400;
  letter-spacing: 0.1px;
  margin: 0.5rem 0;
`;

export const Cover = styled.div`
  > * {
    display: block;
    width: 100%;
  }

  img {
    border-radius: 2px 2px 0 0;
    vertical-align: middle;
    border-style: none;
  }
`;

export const Body = styled.div`
  padding: 24px;
  zoom: 1;

  ::before,
  ::after {
    display: table;
    content: '';
  }

  ::after {
    clear: both;
  }
`;

export const Avatar = styled.div`
  background-color: #f7b801;
  border-radius: 50%;
  height: 40px;
  width: 40px;
  color: white;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 0.75rem;
`;

export const Flex = styled.div`
  display: flex;
`;
